import React from 'react';
import Modal from 'v3/components/Modal';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';

function ConfirmationModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <Modal
      show={isOpen}
      size="lg"
      onHide={onClose}
      heading={<Text color="dark" type="header">Centro de Custo</Text>}
      body={<Text>Deseja realmente sair sem salvar as alterações?</Text>}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <Button variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Sair sem salvar
          </Button>
        </div>
      }
    />
  );
}

export default ConfirmationModal;
